import { Parser } from "xml2js";
import { getItemWebStorage, setItemWebStorage } from "../../../../features/webStorageSaver";
import { store } from "../../../../stateManagement/store";
import { setCameraDirectionsArray, setCameraImageIsRendering, setHasNextFrame, setHasPreviousFrame, setPanoramaCurrentAzimuth, setPanoramaCurrentDate, setPanoramaCurrentDirection, setPanoramaCurrentKm, setPanoramaCurrentKmPlus, setCameraMarkerLatitude, setCameraMarkerLongitude, setPanoramaCurrentPathName, setPanoramaCurrentPositionID, setPanoramaCurrentRoadName, setPanoramaCurrentVideoDocumentID, setPanoramaXMLIsRendering, setPanoramaXMLIsLoading, setReduxMoveRotate, setVideoCurrentDirection, setPanoramaVideoIsPlaying, setXML, setXMLChangeMarker, setShowCameras, setPanoramaWindowIsLoading } from "../../../../stateManagement/reducers/PanoramaSlice";
import { showToastMessage } from "../../../../stateManagement/reducers";

export function changeViewAngle(xmlText: string, hAngle: any, vAngle: any, fov: any) {
    xmlText = xmlText?.replace(`hlookat			="0"`, `hlookat			="${hAngle}"`);
    xmlText = xmlText?.replace(`vlookat			="0"`, `vlookat			="${vAngle}"`);
    xmlText = xmlText?.replace(`fov				="90"`, `fov				="${fov}"`);
    return xmlText;
}

export function changeFov(xmlText: string) {
    xmlText = xmlText?.replace(`limitview		="auto"
                />
            
                <data', '<data name="$1">$2&#44;$3</data>`, `limitview="auto"
                />
                
                <action name="changeFov">
                set(fov, %1);  <!-- Устанавливаем значение fov на переданное значение -->
                tween(fov, %1, 0.5, linear);  <!-- Создаем анимацию изменения fov в течение 0.5 секунды -->
                </action>
                <data', '<data name="$1">$2&#44;$3</data>`);
    return xmlText;
}

function getPlayUpLayer(xmlDoc: any) {
    const playUpLayer = xmlDoc.createElement("layer")
    playUpLayer.setAttribute("name", "playUp")
    playUpLayer.setAttribute("alpha", "0.5")
    playUpLayer.setAttribute("url", "/assets/images/pano/upMove.png")
    playUpLayer.setAttribute("onclick", "if(layer[playDownEnd].visible, set(layer[playUp].alpha, 1); js(playPanorama('next')), if(layer[playDown].alpha == 0.5, if(layer[playUp].alpha == 1, set(layer[playUp].alpha, 0.5), set(layer[playUp].alpha, 1)); js(playPanorama('next')), set(layer[playDown].alpha, 0.5); js(playPanorama('back'))))")
    playUpLayer.setAttribute("width", "35")
    playUpLayer.setAttribute("height", "35")
    playUpLayer.setAttribute("align", "left")
    playUpLayer.setAttribute("visible", "true")
    playUpLayer.setAttribute("x", "-7")
    playUpLayer.setAttribute("y", "12")
    return playUpLayer
}

function getPlayDownLayer(xmlDoc: any) {
    const playDownLayer = xmlDoc.createElement("layer")
    playDownLayer.setAttribute("name", "playDown")
    playDownLayer.setAttribute("onclick", "if(layer[playUpEnd].visible, set(layer[playDown].alpha, 1); js(playPanorama('back')), if(layer[playUp].alpha == 0.5, if(layer[playDown].alpha == 1, set(layer[playDown].alpha, 0.5), set(layer[playDown].alpha, 1)); js(playPanorama('back')), set(layer[playUp].alpha, 0.5); js(playPanorama('next'))))")
    playDownLayer.setAttribute("alpha", "0.5")
    playDownLayer.setAttribute("url", "/assets/images/pano/downMove.png")
    playDownLayer.setAttribute("width", "35")
    playDownLayer.setAttribute("height", "35")
    playDownLayer.setAttribute("align", "left")
    playDownLayer.setAttribute("visible", "true")
    playDownLayer.setAttribute("x", "-7")
    playDownLayer.setAttribute("y", "47")
    return playDownLayer
}

function getPlayUpEndLayer(xmlDoc: any) {
    const playUpEndLayer = xmlDoc.createElement("layer")
    playUpEndLayer.setAttribute("name", "playUpEnd")
    playUpEndLayer.setAttribute("alpha", "0.5")
    playUpEndLayer.setAttribute("url", "/assets/images/pano/stop.png")
    playUpEndLayer.setAttribute("onover", "set(layer[playUpEnd].alpha, 1)")
    playUpEndLayer.setAttribute("onout", "set(layer[playUpEnd].alpha, 0.5)")
    playUpEndLayer.setAttribute("width", "35")
    playUpEndLayer.setAttribute("height", "35")
    playUpEndLayer.setAttribute("align", "left")
    playUpEndLayer.setAttribute("visible", "false")
    playUpEndLayer.setAttribute("x", "-7")
    playUpEndLayer.setAttribute("y", "12")
    return playUpEndLayer
}

function getPlayDownEndLayer(xmlDoc: any) {
    const playDownEndLayer = xmlDoc.createElement("layer")
    playDownEndLayer.setAttribute("name", "playDownEnd")
    playDownEndLayer.setAttribute("alpha", "0.5")
    playDownEndLayer.setAttribute("url", "/assets/images/pano/stop.png")
    playDownEndLayer.setAttribute("onover", "set(layer[playDownEnd].alpha, 1)")
    playDownEndLayer.setAttribute("onout", "set(layer[playDownEnd].alpha, 0.5)")
    playDownEndLayer.setAttribute("width", "35")
    playDownEndLayer.setAttribute("height", "35")
    playDownEndLayer.setAttribute("align", "left")
    playDownEndLayer.setAttribute("visible", "false")
    playDownEndLayer.setAttribute("x", "-7")
    playDownEndLayer.setAttribute("y", "47")
    return playDownEndLayer
}

export function addButtonsToPano(xmlText: string) {
    let panoramaVideoIsPlaying = store.getState().panorama.panoramaVideoIsPlaying
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlText, "text/xml")
    const krpano = xmlDoc.querySelector("krpano");
    const compasAction = xmlDoc.querySelector("[name='compass_update_rotate']");
    if (compasAction) {
        compasAction.textContent += "add(layer[playButtons].rotate, dst, 180);"
    }
    const isReadyAction = xmlDoc.querySelector("[name='is_ready']");
    if (isReadyAction) {
        let windowObject: any = window
        if (isReadyAction?.textContent?.includes("set(layer[up-end].visible, true)")) {
            isReadyAction.textContent += "set(layer[playUpEnd].visible, true);"
            isReadyAction.textContent += "set(layer[playUp].alpha, 0.5);"
            isReadyAction.textContent += "set(layer[playUp].visible, false);"
            panoramaVideoIsPlaying && windowObject.playPanorama('next')
        }
        else {
            isReadyAction.textContent += "set(layer[playUpEnd].visible, false);"
            isReadyAction.textContent += "set(layer[playUp].visible, true);"
        }
        if (isReadyAction?.textContent?.includes("set(layer[down-end].visible, true)")) {
            isReadyAction.textContent += "set(layer[playDownEnd].visible, true);"
            isReadyAction.textContent += "set(layer[playDown].alpha, 0.5);"
            isReadyAction.textContent += "set(layer[playDown].visible, false);"
            panoramaVideoIsPlaying && windowObject.playPanorama('back')
        }
        else {
            isReadyAction.textContent += "set(layer[playDownEnd].visible, false);"
            isReadyAction.textContent += "set(layer[playDown].visible, true);"
        }
    }
    const playButtonsLayer = xmlDoc.createElement("layer")
    playButtonsLayer.setAttribute("name", "playButtons")
    playButtonsLayer.setAttribute("keep", "true")
    playButtonsLayer.setAttribute("align", "centerbottom")
    playButtonsLayer.setAttribute("x", "110")
    playButtonsLayer.setAttribute("y", "40")
    playButtonsLayer.setAttribute("type", "container")
    playButtonsLayer.setAttribute("width", "20")
    playButtonsLayer.setAttribute("height", "65")
    const playUpLayer = getPlayUpLayer(xmlDoc)
    const playDownLayer = getPlayDownLayer(xmlDoc)
    const playUpEndLayer = getPlayUpEndLayer(xmlDoc)
    const playDownEndLayer = getPlayDownEndLayer(xmlDoc)
    playButtonsLayer?.appendChild(playUpLayer)
    playButtonsLayer?.appendChild(playDownLayer)
    playButtonsLayer?.appendChild(playUpEndLayer)
    playButtonsLayer?.appendChild(playDownEndLayer)
    krpano?.appendChild(playButtonsLayer)
    const serializer = new XMLSerializer();
    const newXmlString = serializer.serializeToString(xmlDoc);
    return newXmlString
}

export function changeSources(xmlText: string) {
    const { irosRestApiUrl } = getItemWebStorage('currentConfig')
    // Корректируем запрос панорамы за кадрами
    xmlText = xmlText?.replace("%irosRestApiUrl%", irosRestApiUrl);
    // Меняем адреса картинок
    xmlText = xmlText?.replace(/url="\/assets\/images\/pano\/up.png"/g, `url="${process.env.PUBLIC_URL}/assets/images/pano/up.png"`);
    xmlText = xmlText?.replace(/url="\/assets\/images\/pano\/down.png"/g, `url="${process.env.PUBLIC_URL}/assets/images/pano/down.png"`);
    xmlText = xmlText?.replace(/url="\/assets\/images\/pano\/stop.png"/g, `url="${process.env.PUBLIC_URL}/assets/images/pano/stop.png"`);
    xmlText = xmlText?.replace(/url="\/assets\/images\/pano\/upFast.png"/g, `url="${process.env.PUBLIC_URL}/assets/images/pano/upFast.png"`);
    xmlText = xmlText?.replace(/url="\/assets\/images\/pano\/downFast.png"/g, `url="${process.env.PUBLIC_URL}/assets/images/pano/downFast.png"`);
    xmlText = xmlText?.replace(/url="\/assets\/images\/pano\/upMove.png"/g, `url="${process.env.PUBLIC_URL}/assets/images/pano/upMove.png"`);
    xmlText = xmlText?.replace(/url="\/assets\/images\/pano\/downMove.png"/g, `url="${process.env.PUBLIC_URL}/assets/images/pano/downMove.png"`);
    // Отлавливаем ошибку с запятой
    xmlText = xmlText?.replace(/<data name="(.+)">(.+),(.+)<\/data>/g, '<data name="$1">$2&#44;$3</data>');
    return xmlText
}

export function parsePanoramaXML(xmlText: string) {
    // Парсинг XML в JSON
    const parser = new Parser();
    parser.parseString(xmlText, (err, jsonData) => {
        for (const item of jsonData.krpano.data) {
            // Проверяем, есть ли у текущего элемента атрибут 'name'
            if (item.$ && item.$.name) {
                // Получаем имя и значение
                const name = item.$.name;
                const value = item._;
                store.dispatch(setReduxMoveRotate(true))
                // Разбор данных о панораме по переменным для дальнейшего использования
                switch (name) {
                    case 'panoInfoLon':
                        {
                            store.dispatch(setCameraMarkerLongitude(parseFloat(value)))
                            setItemWebStorage('cameraMarkerLongitude', parseFloat(value))
                            break;
                        }
                    case 'panoInfoLat':
                        {
                            store.dispatch(setCameraMarkerLatitude(parseFloat(value)))
                            setItemWebStorage('cameraMarkerLatitude', parseFloat(value))
                            break;
                        }
                    case 'videoPositionID':
                        {
                            store.dispatch(setPanoramaCurrentPositionID(value))
                            break;
                        }
                    case 'videoDocumentID':
                        {
                            store.dispatch(setPanoramaCurrentVideoDocumentID(value))
                            break;
                        }
                    case 'azimuth':
                        {
                            const azimuth = value ? parseInt(value) : 0
                            setItemWebStorage('panoramaAzimuth', azimuth)
                            store.dispatch(setPanoramaCurrentAzimuth(azimuth))
                            break;
                        }
                    case 'direction':
                        {
                            store.dispatch(setPanoramaCurrentDirection(value))
                            break;
                        }
                    case 'VideoDocumentDate':
                        {
                            if (value != '0') {
                                store.dispatch(setPanoramaCurrentDate(value))
                            }
                            break;
                        }
                    case 'VideoRoad':
                        {
                            store.dispatch(setPanoramaCurrentRoadName(value))
                            break;
                        }
                    case 'VideoPath':
                        {
                            store.dispatch(setPanoramaCurrentPathName(value))
                            break;
                        }
                    case 'VideoKm':
                        {
                            store.dispatch(setPanoramaCurrentKm(value))
                            break;
                        }
                    case 'VideoKmPlus':
                        {
                            store.dispatch(setPanoramaCurrentKmPlus(value))
                            break;
                        }
                }
            }
        }
    });
}

export function parseVideoFrameXML(xmlText: string) {
    xmlText = xmlText?.replace(/num=(\d+)/g, 'num="$1"');
    // Парсинг XML в JSON
    const parser = new Parser();
    parser.parseString(xmlText, (err, result) => {
        if (err) {
            console.error(err);
        } else {
            let dataJson = result.videoFrame;
            for (const key in dataJson) {
                const value: any = dataJson[key][0];
                switch (key) {
                    case 'vidInfoLon':
                        {
                            store.dispatch(setCameraMarkerLongitude(parseFloat(value)))
                            setItemWebStorage('cameraMarkerLongitude', parseFloat(value))
                            break;
                        }
                    case 'vidInfoLat':
                        {
                            store.dispatch(setCameraMarkerLatitude(parseFloat(value)))
                            setItemWebStorage('cameraMarkerLatitude', parseFloat(value))
                            break;
                        }
                    case 'videoPositionID':
                        {
                            store.dispatch(setPanoramaCurrentPositionID(value))
                            break;
                        }
                    case 'videoDocumentID':
                        {
                            store.dispatch(setPanoramaCurrentVideoDocumentID(value))
                            break;
                        }
                    case 'azimuth':
                        {
                            const azimuth = value ? parseInt(value) : 0
                            setItemWebStorage('panoramaAzimuth', azimuth)
                            store.dispatch(setPanoramaCurrentAzimuth(azimuth))
                            break;
                        }
                    case 'direction':
                        {
                            store.dispatch(setPanoramaCurrentDirection(value))
                            break;
                        }
                    case 'cameraCount':
                        {
                            break;
                        }
                    case 'cameraDirections':
                        {
                            store.dispatch(setCameraDirectionsArray(value))
                            break;
                        }
                    case 'videoDocumentDate':
                        {
                            if (value != '0') {
                                store.dispatch(setPanoramaCurrentDate(value))
                            }
                            break;
                        }
                    case 'videoRoad':
                        {
                            store.dispatch(setPanoramaCurrentRoadName(value))
                            break;
                        }
                    case 'videoPath':
                        {
                            store.dispatch(setPanoramaCurrentPathName(value))
                            break;
                        }
                    case 'videoKm':
                        {
                            store.dispatch(setPanoramaCurrentKm(value))
                            break;
                        }
                    case 'videoKmPlus':
                        {
                            store.dispatch(setPanoramaCurrentKmPlus(value))
                            break;
                        }
                    case 'hasNextFrame':
                        {
                            store.dispatch(setHasNextFrame(value === "true"))
                            break;
                        }
                    case 'hasPrevFrame':
                        {
                            store.dispatch(setHasPreviousFrame(value === "true"))
                            break;
                        }
                }
            }
        }
    });
}

function getCameraDirectionURL(irosRestApiUrl: string, videoPositionID: string, cameraDirection: string) {
    return (`${irosRestApiUrl}/Video/CubicFrameImage?VideoPositionId=${videoPositionID}&CubeSideLabel=%27${cameraDirection}%27`)
}

export function parseCameraDirections(cameraDirections: any, videoPositionID: any) {
    const { irosRestApiUrl } = getItemWebStorage('currentConfig');
    let formatterCameraDirections = [...cameraDirections.cameraDirection].sort((a: any, b: any) => {
        const aValue = parseInt(a._, 10);
        const bValue = parseInt(b._, 10);

        if (aValue < -90) {
            return 1;
        }

        if (bValue < -90) {
            return -1;
        }

        return aValue - bValue;
    }).map((item: any) => ({
        url: getCameraDirectionURL(irosRestApiUrl, videoPositionID, item.$.num),
        name: item.$.name ? `${item.$.name}` : `${item._}°`,
    }))
    return formatterCameraDirections
}

export async function getNextFrame(direction: any, fetchNextFrameQuery: any) {
    const { panoramaCurrentPositionID, panoramaCurrentHLookAngle, panoramaCurrentVLookAngle, xmlChangeMarker } = store.getState().panorama
    store.dispatch(setPanoramaXMLIsLoading(true))
    store.dispatch(setPanoramaWindowIsLoading(true))
    const xmlResponse = await fetchNextFrameQuery({ positionID: panoramaCurrentPositionID, direction, hLookAngle: panoramaCurrentHLookAngle, vLookAngle: panoramaCurrentVLookAngle })
    if (xmlResponse && xmlResponse?.data) {
        const xml = xmlResponse?.data
        if (xml.includes('Error')) {
            store.dispatch(setPanoramaXMLIsLoading(false))
            store.dispatch(setPanoramaXMLIsRendering(false))
            store.dispatch(setPanoramaWindowIsLoading(false))
            let messageText = "Ошибка при загрузке панорамы"
            if (xml.includes('Video positions not found')) {
                messageText = 'В заданной позиции кадр не найден'
            } else if (xml.includes("Failed to open video file")) {
                messageText = 'Произошла ошибка во время открытия видеофайла'
            } else if (xml.includes("property not found")) {
                messageText = 'Произошла ошибка во время открытия видеофайла'
            } else if (xml.includes("Не удается найти указанный файл")) {
                messageText = 'Не удается найти указанный файл'
            }
            store.dispatch(showToastMessage({ messageText, messageType: "error", windowType: "panorama" }))
        }
        else {
            store.dispatch(setXML(xml));
            store.dispatch(setShowCameras(xml.includes('<videoFrame>')))
            store.dispatch(setXMLChangeMarker(!xmlChangeMarker))
            store.dispatch(setPanoramaXMLIsLoading(false))
        }
    }
    else {
        store.dispatch(showToastMessage({ messageText: 'Произошла ошибка во время запроса кадра', messageType: "error", windowType: "panorama" }))
        store.dispatch(setPanoramaXMLIsLoading(false))
        store.dispatch(setPanoramaXMLIsRendering(false))
        store.dispatch(setPanoramaWindowIsLoading(false))
    }
}

export async function getFrameAtPos(direction: any, fetchFastNextFrameQuery: any) {
    const { panoramaCurrentDirection, panoramaCurrentKm, panoramaStep, panoramaCurrentHLookAngle, panoramaCurrentVLookAngle, panoramaCurrentVideoDocumentID, xmlChangeMarker } = store.getState().panorama
    store.dispatch(setPanoramaXMLIsLoading(true))
    store.dispatch(setPanoramaWindowIsLoading(true))
    // Настраиваем шаг быстрой стрелки
    let newKm = '0'
    // Проверка на направление движения для быстрого шага
    if (direction === 'next' && panoramaCurrentDirection === 'Backward' || direction === 'back' && panoramaCurrentDirection === 'Forward' || direction === 'next' && panoramaCurrentDirection === 'Все') {
        newKm = (parseFloat(panoramaCurrentKm) - (parseFloat(panoramaStep)) / 1000)?.toString()
    } else if (direction === 'back' && panoramaCurrentDirection === 'Backward' || direction === 'next' && panoramaCurrentDirection === 'Forward' || direction === 'back' && panoramaCurrentDirection === 'Все') {
        newKm = (parseFloat(panoramaCurrentKm) + (parseFloat(panoramaStep)) / 1000)?.toString()
    } else {
        console.warn('Не удается сделать следующий шаг')
    }
    const xmlResponse = await fetchFastNextFrameQuery({ videoDocumentID: panoramaCurrentVideoDocumentID, videoKM: newKm, tolerance: 0.01, hLookAngle: panoramaCurrentHLookAngle, vLookAngle: panoramaCurrentVLookAngle })
    if (xmlResponse && xmlResponse?.data) {
        const xml = xmlResponse?.data
        if (xml.includes('Error')) {
            store.dispatch(setPanoramaXMLIsLoading(false))
            store.dispatch(setPanoramaXMLIsRendering(false))
            store.dispatch(setPanoramaWindowIsLoading(false))
            let messageText = "Ошибка при загрузке панорамы"
            if (xml.includes('Video positions not found')) {
                messageText = 'В заданной позиции кадр не найден'
            } else if (xml.includes("Failed to open video file")) {
                messageText = 'Произошла ошибка во время открытия видеофайла'
            } else if (xml.includes("property not found")) {
                messageText = 'Произошла ошибка во время открытия видеофайла'
            } else if (xml.includes("Не удается найти указанный файл")) {
                messageText = 'Не удается найти указанный файл'
            }
            store.dispatch(showToastMessage({ messageText, messageType: "error", windowType: "panorama"  }))
        }
        else {
            store.dispatch(setXML(xml));
            store.dispatch(setShowCameras(xml.includes('<videoFrame>')))
            store.dispatch(setXMLChangeMarker(!xmlChangeMarker));
            store.dispatch(setPanoramaXMLIsLoading(false))
        }
    }
    else {
        store.dispatch(showToastMessage({ messageText: 'Произошла ошибка во время запроса кадра', messageType: "error", windowType: "panorama" }))
        store.dispatch(setPanoramaXMLIsLoading(false))
        store.dispatch(setPanoramaXMLIsRendering(false))
        store.dispatch(setPanoramaWindowIsLoading(false))
    }
}

export async function controlCameraMove(direction: any, videoIsPlaying: boolean) {
    store.dispatch(setVideoCurrentDirection(direction))
    store.dispatch(setPanoramaVideoIsPlaying(!videoIsPlaying))
}

export async function getNextFrameForVideoPlay(type: any, direction: any, fetchNextFrameQuery: any) {
    store.dispatch(setPanoramaXMLIsLoading(true))
    const { panoramaCurrentPositionID, panoramaCurrentHLookAngle, panoramaCurrentVLookAngle, xmlChangeMarker } = store.getState().panorama
    const xmlResponse = await fetchNextFrameQuery({ positionID: panoramaCurrentPositionID, direction, hLookAngle: panoramaCurrentHLookAngle, vLookAngle: panoramaCurrentVLookAngle })
    if (xmlResponse && xmlResponse?.data) {
        const xml = xmlResponse?.data
        if (xml.includes('Error')) {
            store.dispatch(setPanoramaXMLIsLoading(false))
            store.dispatch(setPanoramaVideoIsPlaying(false))
            let messageText = "Ошибка при загрузке панорамы"
            if (xml.includes('Video positions not found')) {
                messageText = 'В заданной позиции кадр не найден'
            } else if (xml.includes("Failed to open video file")) {
                messageText = 'Произошла ошибка во время открытия видеофайла'
            } else if (xml.includes("property not found")) {
                messageText = 'Произошла ошибка во время открытия видеофайла'
            } else if (xml.includes("Не удается найти указанный файл")) {
                messageText = 'Не удается найти указанный файл'
            }
            store.dispatch(showToastMessage({ messageText, messageType: "error", windowType: "panorama"  }))
        }
        else {
            store.dispatch(setPanoramaXMLIsLoading(false))
            store.dispatch(setXML(xml));
            store.dispatch(setXMLChangeMarker(!xmlChangeMarker));
            if (type === "panorama") {
                store.dispatch(setPanoramaXMLIsRendering(true))
            } else {
                store.dispatch(setCameraImageIsRendering(true))
            }
        }
    }
    else {
        store.dispatch(showToastMessage({ messageText: 'Произошла ошибка во время запроса кадра', messageType: "error", windowType: "panorama" }))
        store.dispatch(setPanoramaXMLIsLoading(false))
        store.dispatch(setPanoramaVideoIsPlaying(false))
    }
}